// import external dependencies
import 'jquery';

// Import everything from autoload
//import './autoload/_foundation.js'; import './autoload/_nicepage.js'
import './autoload/_nicepage';

// import local dependencies
import 'custom-event-polyfill'; //IE11 fix
import 'intersection-observer'; //IE11 fix
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import businessDirectory from './routes/businessDirectory';
import taxonomyBusinessCategory from './routes/taxonomyBusinessCategory';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // Business post type archive
  businessDirectory,
  taxonomyBusinessCategory,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js